// Discovery omits future rounds, so their opening time is unknown to the client.
// Poll visible applicant pages to discover openings and retire expired previews.
export const APPLICATION_AVAILABILITY_QUERY_OPTIONS = {
  refetchInterval: 10_000,
} as const;
